import type { TFunction } from 'i18next'
import * as Yup from 'yup'

export const createBaseUserValidationSchema = (t: TFunction) =>
  Yup.object({
    name: Yup.object({
      firstName: Yup.string().default('').required(t('admin.usersPage.userDetails.firstNameMessage')),
      lastName: Yup.string().default('').required(t('admin.usersPage.userDetails.lastNameMessage')),
    }),
    email: Yup.object({
      address: Yup.string()
        .required(t('admin.adminUsersPage.fieldInputErrorMessage.emailIsRequiredErrorMessage'))
        .email(t('admin.adminUsersPage.fieldInputErrorMessage.emailIsInvalidErrorMessage'))
        .default(''),
    }),
  }).defined()
